import type { CepGateway } from '@/application/port/out/CepGateway';
import type { EnderecoResolvido } from '@/domain/model/Endereco';

interface ViaCepResponse {
  cep: string;
  logradouro?: string;
  bairro?: string;
  localidade?: string;
  uf?: string;
  erro?: boolean;
}

/**
 * Adapter HTTP do CepGateway via ViaCEP. Sprint 1.6.
 *
 * TODO Sprint 2: substituir por adapter que chama backend cached
 * (`GET /api/v1/cep/{cep}` via ofetchClient) pra não vazar IP do admin
 * pro serviço externo.
 */
export class ViaCepGateway implements CepGateway {
  async lookup(cep: string): Promise<EnderecoResolvido | null> {
    const digits = cep.replace(/\D/g, '');
    if (digits.length !== 8) return null;
    try {
      const res = await fetch(`https://viacep.com.br/ws/${digits}/json/`);
      if (!res.ok) return null;
      const data = (await res.json()) as ViaCepResponse;
      if (data.erro) return null;
      return {
        cep: digits,
        logradouro: data.logradouro ?? '',
        bairro: data.bairro ?? '',
        cidade: data.localidade ?? '',
        uf: data.uf ?? '',
      };
    } catch {
      return null;
    }
  }
}
